import React from "react";
import {GraphQlSelect} from "./GraphQlSelect";
import {useClientCompanyGroupQueryQuery} from "../../generated/graphql";
import {GraphQlSelectId} from "./GraphQlSelectId";

export const ClientCompanyGroupSelect = (props) => {
    const query = useClientCompanyGroupQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="label" />:<GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}